import axios from 'axios';
import _ from "lodash";
import NProgress from "nprogress";
import appState from "../state/AppStateContainer";



function handleAxiosRequestSuccess(config) {
  // Do something before request is sent
  if (config.progressBar) NProgress.start();
  if (appState.state && appState.state.token) {
    config.headers.authorization = 'Bearer ' + appState.state.token;
  }
  return config;
}

async function handleAxiosRequestError(error) {
  // Do something with request error
  console.log('axiosRequestError', error);
  NProgress.done();
  console.error(error);
  return Promise.reject(error);
}

function handleAxiosResponseSuccess(response) {
  NProgress.done();
  return response;
}

async function handleAxiosResponseError(error) {
  if (_.get(error, 'response.status') === 401) {
    window.location = '/permissionsChanged';
  }

  if (error.message === 'Network Error') {
    console.error('axioserror', error);

    window.location = '/error/internalError';
  }
  // Do something with response error
  NProgress.done();
  console.error(error);
  return Promise.reject(error);
}

const initializeAxios = () => {
	// Include JWT in the header.
	// axios.defaults.headers.common.Authorization = `Bearer ${token}`;

	// Add a response interceptor.
	axios.interceptors.request.use(handleAxiosRequestSuccess, handleAxiosRequestError);
	axios.interceptors.response.use(handleAxiosResponseSuccess, handleAxiosResponseError);
};

export default initializeAxios;
